import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Check from "components/common/check";
import Input from "components/common/input";

const validationSchema = Yup.object().shape({
  housing_expense: Yup.object().shape({
    rejection_reason: Yup.string().required("Denial reason is required"),
    other: Yup.string().when("reason", {
      is: "Other",
      then: (schema) => schema.required("Please specify the reason"),
    }),
    additionalComment: Yup.string().max(500, "Too long"),
  }),
});

const denialOptions = [
  {
    label: "Incomplete/Incorrect Member Name",
    value: "Incomplete/Incorrect Member Name",
  },
  {
    label: "Incomplete/Incorrect Address",
    value: "Incomplete/Incorrect Address",
  },
  {
    label: "Unsupported/Missing Payment Method",
    value: "Unsupported/Missing Payment Method",
  },
  {
    label: "Missing/Incomplete/Corrupted W-9",
    value: "Missing/Incomplete/Corrupted W-9",
  },
  {
    label: "Missing/Incomplete/Corrupted Lease Agreement",
    value: "Missing/Incomplete/Corrupted Lease Agreement",
  },
  {
    label: "Missing/Incomplete/Corrupted Authorization from Health Plan",
    value: "Missing/Incomplete/Corrupted Authorization from Health Plan",
  },
  {
    label: "Missing/Incomplete/Corrupted Check Request",
    value: "Missing/Incomplete/Corrupted Check Request",
  },
  {
    label: "Missing/Incomplete/Corrupted Other Documents",
    value: "Missing/Incomplete/Corrupted Other Documents",
  },
  { label: "Missing/Expired Auth", value: "Missing/Expired Auth" },
  { label: "Other", value: "Other" },
];

const RejectForm = ({ onCancel, selectedId, handleSubmission }) => {
  return (
    <Formik
      initialValues={{
        housing_expense: {
          rejection_reason: "",
          other: "",
          additionalComment: "",
        },
      }}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        handleSubmission(selectedId, values);
      }}
    >
      {({ values, setFieldValue }) => (
        <Form className="form-main">
          <p className="heading-sm">Select Denial Reason</p>

          {denialOptions.map((option) => (
            <Check
              key={option.value}
              label={option.label}
              checked={values.housing_expense.reason === option.value}
              handleChange={(e) => {
                const isChecked = e.target.checked;
                setFieldValue(
                  "housing_expense.rejection_reason",
                  isChecked ? option.value : ""
                );
              }}
            />
          ))}

          <ErrorMessage
            name="housing_expense.rejection_reason"
            component="p"
            style={{ color: "red", fontSize: "0.8rem" }}
          />

          {values.housing_expense.rejection_reason === "Other" && (
            <div>
              <Input
                value={values.housing_expense.other}
                handleChange={(e) =>
                  setFieldValue("housing_expense.other", e.target.value)
                }
                placeholder="Please Specify"
                type="text"
              />
              <ErrorMessage
                name="housing_expense.other"
                component="p"
                className="error-message"
              />
            </div>
          )}

          <div className="mt-4 pb-4">
            <Input
              label="Additional Comment"
              value={values.housing_expense.additionalComment}
              handleChange={(e) =>
                setFieldValue(
                  "housing_expense.additionalComment",
                  e.target.value
                )
              }
              placeholder="Write any additional notes"
              type="text"
            />
            <ErrorMessage
              name="housing_expense.additionalComment"
              component="p"
              className="error-message"
            />
          </div>

          <div className="action gap-2 mt-8">
            <button
              className="secondary-btn w-50"
              type="button"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button className="danger-btn w-50" type="submit">
              Deny Expense Request
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default RejectForm;
